import { useMemo } from 'react';
import { AppInitializing } from '@/screens/Initializing';
import { useAppSelector } from '@/store';

export function AppInitializedGuard(props: ChildrenProps) {
  const appState = useAppSelector(state => state.appState);
  const appInitializing = useMemo(() => appState.initializing, [appState.initializing]);

  if (appInitializing) return <AppInitializing />;

  return props.children;
}